import translations from '@countryLocalization/lang/translations/translations';

const languages: any = {};

if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line global-require
    languages['en-GB'] = require('./translations/enDevelop').default;
} else if (process.env.COUNTRY === 'romania') {
    languages['ro-RO'] = translations;
} else if (process.env.COUNTRY === 'poland') {
    languages['pl-PL'] = translations;
} else if (process.env.COUNTRY === 'croatia') {
    languages['hr-HR'] = translations;
}

export default languages;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/localization/lang/messages.ts